var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLearnMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 334,
  height: 600,
  viewBox: "0 0 334 600",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 328,
  height: 38,
  rx: 4,
  fill: "#DEDDD7"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 90,
  width: 294,
  height: 28,
  rx: 4,
  fill: "#DEDDD7"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 138,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 167.062,
  width: 220,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 196.125,
  width: 262,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 225.188,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  y: 225.188,
  width: 121,
  height: 17.8125,
  rx: 4,
  fill: "#DEDDD7"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  y: 255,
  width: 116,
  height: 37,
  rx: 4,
  fill: "#DEDDD7"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  y: 332,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 332,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 353.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 374.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 395.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 395.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  y: 428,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 428,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 449.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 470.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 491.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 491.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  y: 524,
  width: 60,
  height: 60,
  rx: 4,
  fill: "#DEDDD7"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 524,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 545.036,
  width: 220,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 566.071,
  width: 262,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 587.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 587.107,
  width: 121,
  height: 12.8929,
  rx: 4,
  fill: "#DEDDD7"
})));
export default SvgLearnMore;